export default {
  buildVersion: 23.1,
  cookieExpires: 1,
  useFingerPrint: true,
  mobAppActiveGroup: 9241, //# golomt
  appForce: 0,

  ////gosmart server
  //hubBaseUrl: 'https://mobcoreapi.gosmart.mn/',
  hubBaseUrl: "",
  resBaseUrl: "https://res.gosmart.mn/", 

  //#E GAZAR
  // resBaseUrl: "https://prod-api.gazar.gosmart.mn/cdn/",
  
  //# judCouncil
  // resBaseUrl: "http://103.11.195.40:8086/",
  

  //#golomt
  // resBaseUrl: "https://lms-cdn.golomtbank.local/",
  // resBaseUrl: "https://lms-cdn.golomtbank.com/",

  lmsPages: [
    "lmsWelcome",
    "lmsProfile",
    "lmsParticipant",
    "lmsCourses",
    "lmsCourseView",
    "lmsLessonView",
    "lmsAttend",
    "lmsCalendar",
    "lmsCalendarTeacher",
    "lmsLibrary",
    "lmsDashboard",
    "lmsNotif",
    "lmsPaymentDetail",
    "lmsPaymentList",
    "lmsEventDetail",
    "lmsEventList",
    "lmsMembership",
    "lmsMembershipEthic",
    "lmsMembershipOrg",
    "lmsMembershipPayment",
    "lmsResearchList",
    "lmsNewsList",
    "lmsMagazineList",
    "lmsLegalList",
    "lmsAuditLicenseRequest",
    "lmsFeedback",
    "lmsOffline",
    "lmsConfirm",
    //# TODO admin yed hamaarahgui
    "userProfile",
    "settings",
    "lmsContact",

    "lmsSanamj",
    "lmsAssign",
    "gazarZuvlulHural",
    "lmsExternalCourse",

    "lmsEvent",

    "buddyParticipant",
    "buddyExam",
    "buddyFaq",
    "buddyCulture",
    "buddyVoucher",
    "buddyEvent",
    "buddyQuiz",
    "buddyQuizFill",
    "buddyChecklist",

    "buddyWorker",
    "buddyWorkerDetail",
    "buddyWorkerRead",
    "buddyWorkerRank",

    "buddyChief",
    "buddyChiefDetail",
    "buddyChiefRead",

    "buddyDepartDashboard",
    "buddyDepartReport",

    "buddyAdminDashboard",
    "buddyAdminDashboardDetail",
    "buddyAdminDashboardCalltocare",
    "buddyAdminBuddy",
    "buddyAdminBuddyDetail",

    "buddyAdminChecklistDashboard",
    "buddyAdminChecklist1Detail",
    "buddyAdminChecklist2Depart",
    "buddyAdminChecklist3Employee",

    "buddyAdminReport",
    "buddyAdminReportDetail",
    "buddyAdminReportCheck",
    "buddyAdminReportDepart",

    "buddyAdminAssign",

    "buddyAdminRead",

    "lmsExamr"

  ],

  stfPages: [
    'stfResearcher', 
    'stfCalendar', 
    'stfResearcherList', 
    'stfAdDetail', 
    'stfAdApply',

    'dzHome',
    'dzAdDetail',
    'dzAdApply'
],

elfPages: [
  'elfStudent', 'elfScholarship'
],

  mobApps: [
    {
      id: 9241,
      key: "FUCYnR1jOEqpd_SfjmPWOw",
      name: "For Developers",
      logo: "media/logo/onoo.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["dev.gosmart.mn"],
      hostDev: [
        "192.168.1.5:80380",
        "192.168.0.105:80801",
        "192.168.0.115:8x080",
        "192.168.42.2:8087",
        "192.168.0.100:8080s"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      // id: 9241, //# for gosmart connect
      // key: 'FUCYnR1jOEqpd_SfjmPWOw',
      id: 9249,
      key: "k1P0nf1qAkGwRXB6L4Q8_Q",
      name: "Академи 4.0",
      logo: "media/logo/golomt.png",
      logoFooter: "assets/img/golomt/logo-footer.png",
      skin: "is-golomt",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: [
        "academy.golomtbank.local",
        "academy.golomtbank.com",
        "lmsuat.golomtbank.local",
        "uat-academy.golomtbank.local",
        "lmsdemo.gosmart.mn",
        "golomt.gosmart.mn",
        "sandboxgolomt.gosmart.mn",
        "buddy.gosmart.mn",
        "192.168.205.46",
        "192.168.1.82"
      ],
      hostDev: [
        "192.168.1.91:8c080",
        "172.20.10.3:800802",
        "192.168.1.17:8080",
        "192.168.1.5:808x0",
        "192.168.1.115:8080",
        "192.168.1.115:80x81",
        "192.168.0.105:80809",
        "192.168.42.173:8080",
        //"192.168.1.12:8080",
        "10.0.0.78:8080",
        "192.168.0.16x3:808x0" ,
        "172.20.10.2:8080" ,
        "192.168.0.182:8080" ,
        "172.20.10.10:8080"
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },

      hasHlsServer: true,

      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"

      // hubBaseUrl: 'https://lms-stream.golomtbank.com/',
      // baseUrl: 'https://academy.golomtbank.com/core/',

      // helpPageUrl: "https://lms-help.golomtbank.local",
      // streamBaseUrl: "https://lms-stream.golomtbank.local:8443/",
      // reportBaseUrl: "https://lms-doc.golomtbank.local/",
      // PDFJS_URL: "https://lms-cdn.golomtbank.local/static/pdfobject/web/viewer.html",
      // cdnBaseUrl: "https://lms-cdn.golomtbank.local/",
      // hubBaseUrl: "https://lms-stream.golomtbank.local/",
      // baseUrl: "https://academy.golomtbank.local/core/",
      // resBaseUrl: "https://lms-cdn.golomtbank.local/",
 
      helpPageUrl: "https://lms-help.golomtbank.com",
      streamBaseUrl: 'https://lms-stream.golomtbank.com:8443/',
      reportBaseUrl: 'https://lms-doc.golomtbank.com/',
      PDFJS_URL: 'https://lms-cdn.golomtbank.com/static/pdfobject/web/viewer.html',
      cdnBaseUrl: 'https://lms-cdn.golomtbank.com/',
      hubBaseUrl: 'https://lms-stream.golomtbank.com/',
      baseUrl: 'https://academy.golomtbank.com/core/',
      resBaseUrl: 'https://lms-cdn.golomtbank.com/',
    },
    {
      id: 98,
      name: "Гөү смарт ТМ ХХК",
      key: "zIGhSWMcrLTeOUvByGtMr1",
      logo: "media/icon.png",
      skin: "",
      publicPage: {
        //has: false,
        has: true,
        route: "landingHelp"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [
        "help.gosmart.mn",
        "edu-help.judcouncil.mn",
        "v3.gosmart.mn",
        "192.168.205.46:7050",
        "lmsuat.golomtbank.local:5050"
      ],
      hostDev: [
        "192.168.0.115:80x80",
        "192.168.0.105:80802",
        "192.168.42.2:80808",
        "192.168.0.100:80801", "192.168.0.161:8080_a","192.168.0.16x4:8080_s",
        "192.168.1.5:808x03"
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9157,
      name: "ММНБИ",
      key: "iN2VmYTU1OS0xMTViLTxzc",
      logo: "media/logo/monicpa_2024.png",
      skin: "is-monicpa",
      bgLogin: "assets/img/monicpa2024.png",
      // bgLogin: "assets/img/monicpa.jpg",
      hostPro: ["dynamic.monicpa.mn", "dynamic3.monicpa.mn", "monicpa.gosmart.mn"],
      hostDev: [
        "192.168.1.115:808x0",
        "192.168.0.105:80807",
        "192.168.0.100:8080_x","192.168.0.173:808x0", "192.168.0.171:808_0",
        "192.168.1.2:8081",
        "192.168.1.64:8x080",
        "192.168.1.17:80c80",
        "192.168.42.2:8089",
        "192.168.0.1x82:80x80"
      ],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      // v5ExamBaseUrl: "http://192.168.0.115:8000",
      reportBaseUrl: "https://reportmnbi.gosmart.mn/",
      v5ExamBaseUrl: "http://exam.monicpa.mn",
      helpPageUrl: "http://support.gosmart.mn",
      v2BaseUrl: "http://office.monicpa.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://dynamic.monicpa.mn/core/",
      // baseUrl: 'https://devapi.gosmart.mn/', 
      baseUrl: "https://dynamic.monicpa.mn/mobcore/"
    },
    {
      id: 6126,
      name: "МУТМЗН",
      key: "JOI7zQxTsAZZXS21cEbaPq",
      logo: "media/logo/tmz.png",
      //bgLogin: "assets/img/img15.png",
      bgLogin: "assets/img/cpta.png",
      skin: "is-cpta",
      hostPro: ["members.cpta.mn", "cpta.gosmart.mn"],
      hostDev: [
        "192.168.1.91:80x80",
        "192.168.1.91:8081",
        "192.168.1.17:80x80",
        "172.20.10.3:80x800",
        "192.168.0.105:80802",
        "192.168.0.115:80x80",
        "192.168.1.5:80x800",
        "192.168.42.2:8089",
        "192.168.0.100:8080_2", "192.168.0.173:80x80_s"
      ],
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn", v2BaseUrl: "http://cpta.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coreTMZ/",
      baseUrl: "https://members.cpta.mn/mobcore/"
    },
    {
      id: 9161,
      key: "cAtbPfwB2VFwAMX3lm1Z0H",
      name: "ММҮИ",
      logo: "media/logo/mica.jpg",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: ["v3.mica.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80801",
        "192.168.0.105:80801",
        "192.168.0.100:80803",
        "192.168.42.2:80803",
        "192.168.1.5:80x803"
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9166,
      name: "Номин холдинг",
      key: "a_qkflbHjU_np4KIz_eImP",
      logo: "media/logo/nomin.jpg",
      bgLogin: "assets/img/img15.png",
      hostPro: ["nomin.gosmart.mn"],
      hostDev: [
        "192.168.0.105:80820",
        "192.168.42.2:80809",
        "192.168.0.100:8080_s"
      ],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nomin.gosmart.mn/core/",
      baseUrl: "https://nomin.gosmart.mn/mobcore/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9226,
      name: "Moore Audit",
      key: "N0lyUq26NkeOPob6u8unmg",
      logo: "media/logo/moore.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["mooreaudit.gosmart.mn"],
      hostDev: ["192.168.0.115:80808", "192.168.0.105:80808", "192.168.42.2:80802"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9231,
      name: "BizGuide",
      key: "dQXUXRo_zE6OJ6kXSw0_OA",
      skin: "is-bizguide",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      logo: "media/logo/bizguide.png",
      logoFooter: "assets/img/bizguide/logo-footer.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["learning.bizguide.mn", "learning.bizguide.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9234,
      name: "Бяцхан тоочид",
      key: "xlM9EBJS4UOJholOygbWyw",
      logo: "media/logo/eboard.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["eboard.gosmart.mn"],
      hostDev: ["192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9162,
      name: "Бичил глобус",
      key: "bANNURFrgQOmLOrt8DHpTi",
      logo: "media/logo/bichil.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["bg.gosmart.mn"],
      hostDev: ["192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9240,
      name: "Архивын Ерөнхий газар",
      key: "GYwwpUowV0uPVAOtqg2vcA",
      logo: "media/logo/archives.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["archives.gosmart.mn"], 
      hostDev: ["192.168.0.115:80x80", "192.168.42.2:80809",
      , "192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 1104,
      //name: "Төрийн албаны цахим сургалт",
      //logo: "media/logo/soyombo.png",
      //name: "Динамик Цахим сургалтын платформ",
      name: "Цахим сургалт",
      //logo: "media/logo/onoo.png",
      logo: "media/logo/soyombo.png",
      bgLogin: "assets/img/covid.svg",
      skin: "gov",
      key: "oXSBUpThuoeNxcra7HH3Em",
      hostPro: [
        "demo.gosmart.mn",
        "learning.bizguide.mn",
        "lms.onoo.mn",
        "new.onoo.mn"
      ],
      hostDev: [
        "192.168.0.115:80x80",
        "192.168.1.5:80x80",
        "172.20.10.3:808x00",
        "192.168.0.105:80800",
        "192.168.42.2:8087",
        "192.168.0.100:8080", "192.168.0.16z8:80z80_x", "192.168.0.171:8080_2",  "192.168.0.16x3:808x0"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      //v5ExamBaseUrl: "http://exam.onoo.mn",
      v5ExamBaseUrl: "http://192.168.0.115:8000",
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9233,
      name: "Мал эмнэлгийн ерөнхий газар",
      key: "HMk8BCDrIEe1hxj6f6JQyA",
      hostPro: ["vetdrug.mn", "www.vetdrug.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.0.100:8080_1"],
      // publicPage: {
      //   has: true,
      //   route: 'vet-med'
      // },

      hasHomePage: true,
      defaultHome: "vet-med",
      helpPageUrl: "http://support.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9237,
      name: "asset.ubtraffic",
      key: "o_usZfT6uEqqyNdRP5vVpg",
      helpPageUrl: "http://support.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      logo: "media/logo/ubtraffic.png",
      logoFooter: "assets/img/ubtraffic/logo-footer.png",
      skin: "",
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      hostPro: ['asset.gosmart.mn', 'asset.ubtraffic.mn'],
      hostDev: ["192.168.0.115:80x80", '192.168.0.105:80801', 
      '192.168.0.100:8080_2', '192.168.0.173:80z80_2', '192.168.0.161:80_80',  '192.168.0.164__:8080',
      '192.168.42.2:8081', 
      '192.168.1.5:808x09'],
      register: false,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9238,
      name: "zhut.report",
      key: "U1ZjGhgPIE_unNxET2TYwQ",
      helpPageUrl: "http://support.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9250,
      key: "KFCTQHTYZESz0hBJnqclzQ",
      name: "Голомт Академи",
      logo: "media/logo/golomt.png",
      skin: "",
      publicPage: {
        has: true,
        route: "landingHelp"
      },
      hostPro: ["lms-help.golomtbank.local"],
      hostDev: [
        "192.168.42.2:8081",
        "192.168.0.105:80802",
        "192.168.0.100:80802",
        "192.168.1.5:808x04"
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: "https://lms-stream.golomtbank.local:8443/",
      reportBaseUrl: "https://lms-doc.golomtbank.local/",
      PDFJS_URL:
        "https://lms-cdn.golomtbank.local/static/pdfobject/web/viewer.html",
      cdnBaseUrl: "https://lms-cdn.golomtbank.local/",
      hubBaseUrl: "https://lms-stream.golomtbank.local/",
      baseUrl: "https://academy.golomtbank.local/core/",
      resBaseUrl: "https://lms-cdn.golomtbank.local/"
    },
    {
      id: 9245,
      name: "Нийгмийн даатгал",
      logo: "media/logo/ndaatgal.jpg",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "7CuefISBZE6y1I2Zkt1XtQ",

      hostPro: ["nd.gosmart.mn", "www.nd.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80860",
        "192.168.0.105:80801",
        "192.168.0.100:80802", "192.168.0.173:80x80", "192.168.0.1z68:80z80_2",
        "192.168.42.2:8080",
        "192.168.1.5:808120"
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nd.gosmart.mn/core/",
      baseUrl: "https://nd.gosmart.mn/mobCore/"
    },

    {
      id: 9293,
      name: "Нийгмийн даатгал",
      logo: "media/logo/ndaatgal.jpg",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "huD_gxG1X06PKZ6Po2Rw_A",

      hostPro: ["surgalt.ndaatgal.mn"],
      hostDev: [
        "192.168.0.115:8080x0",
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nd.gosmart.mn/core/",
      baseUrl: "https://nd.gosmart.mn/mobCore/"
    },

    {
      id: 9246,
      name: "Muren",
      logo: "https://res.gosmart.mn/media/icon.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "8EnZS_dGbkipGzqRPPMsgA",

      hostPro: ["muren.gosmart.mn"],
      hostDev: ["192.168.0.105:8082", "192.168.0.100:808096"],
      register: false,
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9247,
      name: "Монголын Үндэсний <br />Мал Эмнэлгийн Холбоо",
      logo: "media/logo/mvma.png",
      skin: "is-mvma",
      logoFooter: "",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      key: "IpHO1B8Q4EyqfNRuTJaTHg",
      hostPro: ["mvma.gosmart.mn", "vet-edu.mn", "www.vet-edu.mn"],
      hostDev: [
        "192.168.0.105:80801",
        "192.168.0.100:80801",
        "192.168.1.5:808120",
        "192.168.42.2:80808"
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      v2BaseUrl: "http://app.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9235,
      name: "Зүтгүүрийн аж ахуйн алба",
      logo: "media/logo/ubtz2023.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "OorU4s35GE_30FR_ubbdwA",

      hostPro: ["railway.gosmart.mn", "my-railway.com", "www.my-railway.com",],
      hostDev: [
        "192.168.1.7:80x80",
        "192.168.0.105:8080_s",
        "192.168.1.115:8x081",
        "192.168.0.100:8080_j",
        "192.168.42.2:8081",
        "192.168.0.100:8080_tch",
        "192.168.0.178:8080_x",
        "172.20.10.3:80x80"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: 'https://www.my-railway.com/core/',
      // baseUrl: 'https://my-railway.com/mobCore/',
      v2BaseUrl: "https://v2.railway.gosmart.mn",
      hubBaseUrl: 'https://railway.gosmart.mn/core/',
      baseUrl: 'https://railway.gosmart.mn/mobCore/',
    },
    {
      id: 9362,
      name: "Вагон ашиглалтын депо",
      logo: "media/logo/ubtz2023.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "Gl_OhK0NuEeh8WK7lUo5tQ",

      hostPro: ["vchd3.gosmart.mn"],
      hostDev: ["192.168.1.115:80x81"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.vchd3.gosmart.mn",
      hubBaseUrl: 'https://vchd3.gosmart.mn/core/',
      baseUrl: 'https://vchd3.gosmart.mn/mobCore/',
    },
    {
      id: 9368,
      name: "Зүүнхараа дахь ачааны вагон засварын депо",
      nameShort: "Академи",
      logo: "media/logo/vchd1.jpg",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "LEjQLJhBcUa5lBTyIhyiEw",

      hostPro: ["vchd1.gosmart.mn"],
      hostDev: ["192.168.1.115:808x1"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.vchd1.gosmart.mn",
      hubBaseUrl: 'https://railway.gosmart.mn/core/',
      baseUrl: 'https://railway.gosmart.mn/mobCore/',
    },
    {
      id: 9351,
      name: "Дохиолол холбооны 2-р анги",
      logo: "media/logo/shch2.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "Rqu6_2_7P0m5EKke_d7ZbQ",

      hostPro: ["shch2.gosmart.mn"],
      hostDev: [
        "192.168.1.115:80x80",
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.shch2.gosmart.mn",
    },
    {
      id: 9363,
      name: "Дохиолол холбооны 1-р анги",
      logo: "media/logo/ubtz2023.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "2b2IXy7RjEi9PtqHvoxCPA",

      hostPro: ["shch1.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80x80",
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.shch1.gosmart.mn",
    },
    {
      id: 9132,
      //name: "Соёл урлагийн их сургууль",
      name: "СУИС",
      logo: "media/logo/mnuac-mini.png",
      bgLogin: "assets/bg/mnuac.png",
      skin: "is-mnuac",
      key: "xFo2zg983Esakr6rtQEu2Q",
      hostPro: ["open.mnuac.edu.mn", "smart.mnuac.edu.mn", 'openmnuac.gosmart.mn'],
      hostDev: ["192.168.1.115:8x080", "192.168.1.64:8080",
      "192.168.0.1x63:808x0"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: "mnuac"
      },
      learnConfig: {
        course: {
          showAlert: true,
          thumb: {
            orientation: 'landscape',
            mode: 'crop'
          }
        }
      },
      //tvr haav
      register: false,

      cdnBaseUrl: 'https://mnuac-cdn.gosmart.mn/',

      helpPageUrl: "http://smart.mnuac.edu.mn",
      v2BaseUrl: "http://office.mnuac.edu.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hasStreamServer: false,
      hubBaseUrl: "https://app.gosmart.mn/coreMNUAC/",
      baseUrl: "https://mobcoremnuac.gosmart.mn/"
    },
    {
      id: 9229,
      name: "Соёл урлагийн их сургууль",
      logo: "media/logo/mnuac-mini.png",
      bgLogin: "assets/bg/mnuac.png",
      skin: "",
      key: "u4q70iDUM024Uug21mY_5A",
      hostPro: ["surgalt.mnuac.edu.mn"],
      hostDev: ["192.168.0.105:80880"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,

      helpPageUrl: "http://smart.mnuac.edu.mn",
      v2BaseUrl: "http://office.mnuac.edu.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coreMNUAC/",
      baseUrl: "https://mobcoremnuac.gosmart.mn/"
    },
    {
      id: 9251,
      name: "ГрэйпСити Монгол",
      logo: "media/logo/grapecity_mini.png",
      bgLogin: "assets/img/orgs/grapecity.png",
      skin: "",
      key: "125LWBl5OkSL0axKGzSIyQ",
      hostPro: ["grapecity.gosmart.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9252,
      name: "ХХҮЕГ",
      logo: "media/logo/halamj.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "1KPU_UlFH0eSKjt2_SGn1g",
      hostPro: ["halamj.gosmart.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://halamj.gosmart.mn/core/",
      baseUrl: "https://halamj.gosmart.mn/mobCore/"
    },
    {
      id: 9254,
      name: "Удирдлагын академи",
      logo: "media/logo/noah.png",
      bgLogin: "assets/img/state2024.png",
      // bgLogin: "assets/img/state.png",
      skin: "is-state",
      key: "Ow9wnhp88kGyJbJHLeh1ww",
      hostPro: [
        "surgalt.gov.mn",
        "onoo-academy.gosmart.mn",
        "state.gosmart.mn",
        "academy.gosmart.mn",
        "192.168.0.105:701"
      ],
      hostDev: [
        "192.168.1.91:8x080",
        "192.168.1.17:8080",
        "192.168.0.105:80801",
        "192.168.0.105:701",
        "192.168.0.100:80801", '192.168.0.168:8080',
        "192.168.1.5:808x0"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },

      v5ExamBaseUrl: "http://exam.surgalt.gov.mn",

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      hasStreamServer: true,
      streamBaseUrl: "https://stream-academy-ssl.gosmart.mn/",
      reportBaseUrl: "https://academy-report.gosmart.mn/",
      PDFJS_URL: "https://onoo-academy.gosmart.mn/academy/pdfobject/web/viewer.html",
      cdnBaseUrl: "https://academy-cdn.gosmart.mn/",
      // hubBaseUrl: "https://surgalt.gov.mn/core/",
      // baseUrl: "https://surgalt.gov.mn/mobCore/"
      hubBaseUrl: "https://onoo-academy.gosmart.mn/core/",
      baseUrl: "https://onoo-academy.gosmart.mn/mobCore/"
    },
    {
      id: 9256,
      name: "Training Hub",
      logo: "media/icon.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "Sv_RD56LTEWyS_4krRvW6A",
      hostPro: ["traininghub.gosmart.mn"],
      hostDev: ["192.168.1.17:80x80"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },

      v5ExamBaseUrl: "http://exam.onoo.mn",
      v2BaseUrl: "https://v2.traininghub.gosmart.mn",
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },
    {
      id: 9308,
      name: "Санхүү, Татварын онлайн тестийн систем",
      logo: "media/logo/so-0627.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "zEwrHoU9_kaLwWdrxdgVHg",
      hostPro: ["test.gosmart.mn"],
      hostDev: ["192.168.0.115:80x80", "192.168.0.105:80801", "192.168.0.100:80801"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9253,
      name: "Тээврийн автомашины дарааллын систем",
      logo: "media/logo/tads.png",
      skin: "is-tads",
      logoFooter: "",
      publicPage: {
        has: false,
        route: "landingTads"
      },
      key: "aal8X8oVMkW9CVK0bwCS3g",
      hostPro: ["tads.gosmart.mn"],
      hostDev: [
        "192.168.0.105:80801",
        "192.168.0.100:80801",
        "192.168.1.5:80x80y",
        "192.168.42.2:80808"
      ],
      //register: false,
      fileUploadSize: {
        default: {
          size: 5120,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 5мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 100,
      name: "Зайн сургалтын систем",
      key: "TXImUpThuPeVxcrt1QH3Ev",
      skin: "is-mta",
      logo: "media/logo/mta.svg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["e-learning.mta.mn"],
      hostDev: ["192.168.0.115:8x081", "192.168.0.105:80802", "192.168.42.2:80809", "192.168.0.18x2:80x80"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      PDFJS_URL: "https://cdn.mta.mn/pdfobject/web/viewer.html",
      hubBaseUrl: "https://e-learning.mta.mn/core/",
      baseUrl: "https://e-learning.mta.mn/mobCore/"
    },
    {
      id: 9257,
      name: "Болорболд",
      key: "lD_H42EAqUG1OIxd96UNlw",
      logo: "media/logo/bolorbold.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["bolorbold.gosmart.mn"],
      hostDev: ["192.168.1.10:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9258,
      name: "RS2 Consulting",
      key: "qfPEUNVov0STDXrAcyshxg",
      logo: "media/logo/rs2.jpg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["rs2.gosmart.mn"],
      hostDev: ["192.168.1.10:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9259,
      name: "Орчлон сургууль",
      key: "22HVuYbPRk_ZHdD9yBr5dg",
      logo: "media/logo/orchlon.png",
      bgLogin: "assets/img/orchlon.png",
      skin: "is-orchlon",
      hostPro: ["time.orchlon.mn", "orchlon.gosmart.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9260,
      name: "НЭКСТ Групп",
      key: "iR4il5S7u0eaX0F0Fi02rQ",
      logo: "media/logo/next.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["next.gosmart.mn"],
      hostDev: ["192.168.0.115:80x80", "192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9262,
      name: "Suld United LLC",
      key: "PeqflMH8GEWkS2NkZYldTg",
      logo: "media/logo/nexus.png",
      bgLogin: "assets/img/nexus.jpg",
      hostPro: ["nexusauto.gosmart.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 1103,
      name: "EPolice",
      logo: "media/logo/epolice.png",
      bgLogin: "assets/bg/epolice.png",
      skin: "",
      key: "OFImDiThxPeVxcrt1QH3Tz",
      hostPro: ["epv2.gosmart.mn"],
      hostDev: ["192.168.0.115:80880", "192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //tvr haav
      register: false,

      helpPageUrl: "https://help.gosmart.mn",
      v2BaseUrl: "http://epadmin.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "http://103.9.88.248:9090/",
      baseUrl: "https://epconnector.gosmart.mn/"
    },
    {
      id: 9263,
      name: "IPOM",
      key: "4h_JOkAF_kO87_SmEY6gHg",
      logo: "media/logo/ipom.png",
      bgLogin: "assets/img/ipom.jpg",
      hostPro: ["ipbrokerage.ipom.mn"],
      hostDev: ["192.168.0.105:80809", "192.168.0.100:8080_2"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200MB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingIpom",
        systemName:
          "ОЮУНЫ ӨМЧИЙН ЗУУЧЛАЛ БОЛОН ИТГЭМЖЛЭГДСЭН ТӨЛӨӨЛӨГЧИЙН БҮРТГЭЛИЙН СИСТЕМ",
        mainObjectTypeId: 526,
        mainTypeKey: "ipomBrokerAgentType"
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9263,
      name: "IPOM",
      key: "4h_JOkAF_kO87_SmEY6gHg",
      logo: "media/logo/ipom.png",
      bgLogin: "assets/img/ipom.jpg",
      hostPro: ["iplicense.ipom.mn"],
      hostDev: ["192.168.0.115:89080", "192.168.0.100:8080_3"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200MB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingIpom",
        systemName: "ОЮУНЫ ӨМЧИЙН ЛИЦЕНЗИЙН БҮРТГЭЛИЙН МЭДЭЭЛЛИЙН СИСТЕМ",
        mainObjectTypeId: 527,
        mainTypeKey: "ipomCopyRightType"
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9264,
      name: "Цахим сургалтын платформ",
      key: "ffXfr62SE0GtId4hqhWTKA",
      logo: "media/logo/gs25.png",
      bgLogin: "assets/img/gs25.png",
      hostPro: ["gs25.gosmart.mn"],
      hostDev: ["192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9265,
      name: "Банк Санхүүгийн Академи",
      nameShort: "Академи",
      groupNameHide: true,
      groupLogoWidth: 183,
      key: "8k8EhKtt7kiB5jB1t_7kMQ",
      skin: "bfa", 
      logo: "media/logo/bfa.png",
      bgLogin: "assets/img/bfa.jpg",
      hostPro: ['e.bfa.mn', 'bfa.gosmart.mn'],
      hostDev: ['192.168.0.115:80x80', 
      '192.168.0.100:8080_2', "192.168.0.173:8080_x", "192.168.0.171:80820_2", "192.168.0.18_6:8080"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://e.bfa.mn/core/",
      baseUrl: "https://e.bfa.mn/mobCore/",

      //  hubBaseUrl: "https://e.bfa.mn/core/",
      //  baseUrl: "https://e.bfa.mn/mobCore/"

      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9274,
      name: "Монголын Өмгөөлөгчдийн холбоо",
      key: "sAKw_rbOfU_J_dQwdPgjDw",
      skin: "",
      logo: "media/logo/ama.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['ama.gosmart.mn'],
      hostDev: ['192.168.0.115:80840', 
      '192.168.0.100:808s0'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    },
    {
      id: 1104,
      name: "Динамик платформ",
      key: "oXSBUpThuoeNxcra7HH3Em",
      skin: "",
      logo: "media/logo/gosmart-05.png",
      bgLogin: "assets/img/bfa.jpg",
      hostPro: ['new.gosmart.mn'],
      hostDev: ['192.168.0.115:80800', '192.168.0.100:8080_1'
        ,'192.168.0.1x63:808x0'
      ],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingShuffle",
        layout: 'atis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    }
    ,
    {
      id: 9266,
      name: "Грийн групп",
      key: "7oFSnYR_c0mXQJLo5jlT7g",
      skin: "greengroup",
      logo: "media/logo/greengroup.png",
      bgLogin: "assets/img/greengroup.jpg",
      hostPro: ['greengroup.gosmart.mn'],
      hostDev: [
        '192.168.0.115:80800', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    }
    ,
    {
      id: 9271,
      name: "Дүрслэх урлагийн академи дээд сургууль",
      key: "_KmTQUYcOkqoxqB_tq8k2g",
      skin: "duads",
      logo: "media/logo/duads.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['mafa.gosmart.mn'],
      hostDev: [
        '192.168.0.115:80801', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },    
    {
      id: 9272,
      name: "УБТЗ Залуучуудын төв зөвлөл",
      key: "RAyfiIR2S0CxtGrponbfCg",
      skin: "youthubtz",
      logo: "media/logo/youthubtz.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['www.youthubtz.mn', 'youthubtz.mn'],
      hostDev: [
        '192.168.0.115:80x80', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/",
      v2BaseUrl: "https://v2.youthubtz.mn",
    },

    {
      id: 9272,
      name: "УБТЗ Залуучуудын төв зөвлөл",
      key: "RAyfiIR2S0CxtGrponbfCg",
      skin: "is-youth",
      logo: "media/logo/youthubtz.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['www.uapp.gosmart.mn', 'uapp.gosmart.mn'],
      hostDev: [
        '192.168.0.115:808x0', 
        '192.168.0.163:8080',
        '192.168.1.7:8x080'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      directPage: {
        has: true,
        route: "homeyouth",
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/",
      v2BaseUrl: "https://v2.youthubtz.mn",
    },

    // {
    //   id: 9275,
    //   name: "Цагдаа, дотоодын цэргийн сургалтын нэгдсэн төв",
    //   key: "jSUk2F5JX0KaPdXnKwgdyg",
    //   skin: "",
    //   logo: "media/logo/police.png",
    //   //bgLogin: "assets/img/bfa.jpg",
    //   hostPro: ['police.gosmart.mn'],
    //   hostDev: ['192.168.0.115:80880', 
    //   '192.168.0.100:8080_x'],
    //   fileUploadSize: {
    //     default: {
    //       size: 2048000,
    //       msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
    //     },
    //     student: {
    //       size: 102400,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
    //     }
    //   },
    //   learnConfig: {
    //     course: {
    //       showAlert: true
    //     }
    //   },
    //   publicPage: {
    //     has: false,
    //     route: "landingShuffle",
    //     layout: 'bendis'
    //   },
    //   register: false,
    //   helpPageUrl: "http://support.gosmart.mn",
    //   streamBaseUrl: "https://stream-gate.gosmart.mn/",
    //   // hubBaseUrl: "https://bfa.gosmart.mn/core/",
    //   // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    // },
    {
      id: 9281,
      name: "Актив групп",
      key: "ftlPgZFMgUuMs_AeDKc_mA",
      skin: "",
      logo: "media/logo/active.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['active.gosmart.mn'],
      hostDev: ['192.168.0.115:8080_x', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 10240,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 10MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    },
    {
      id: 9282,
      name: "Зам тээврийн залуучуудын хөгжлийн зам зөвлөл",
      key: "RS5PVhwsjEm_6OXpHwjsIw",
      skin: "",
      logo: "media/logo/rtydc.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['www.rtydc.mn','rtydc.mn'],
      hostDev: ['192.168.0.115:8080_x', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 10240,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 10MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "http://v2.rtydc.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9283,
      name: "",
      key: "qulEvTkHkUqd4VCnJh1TUw",
      skin: "magic",
      logo: "media/logo/magic.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['magicchoice.magicgroup.mn'],
      hostDev: ['192.168.1.91:80c80', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9284,
      name: "Surgalt.opengov.mn",
      key: "o9debinJsECMKBt8H49KCw",
      skin: "dataland-mofa",
      logo: "media/logo/dataland-mofa.png",
      bgLogin: "assets/img/dataland.png",
      hostPro: ['surgalt.opengov.mn', 'mofa.gosmart.mn'],
      hostDev: ['192.168.0.115:80980', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      hasStreamServer: false,
      helpPageUrl: "http://support.gosmart.mn",
      //streamBaseUrl: "https://stream-gate.gosmart.mn/",
      PDFJS_URL: "https://mofa-cdn.gosmart.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "https://mofa-app.gosmart.mn",
       hubBaseUrl: "https://mofa.gosmart.mn/core/",
       baseUrl: "https://mofa.gosmart.mn/mobCore/",
    },

    {
      id: 9285,
      name: "Эрдмийн ундарга сургалтын төв",
      key: "Ll4G3PRHT0GnjbGr3ou_bw",
      //skin: "magic",
      logo: "media/logo/erdem.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['erdem.gosmart.mn'],
      hostDev: ['192.168.0.115:80x80', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9287,
      name: "ХХААХҮЯ - ХЯНАЛТ-ШИНЖИЛГЭЭ, ҮНЭЛГЭЭ, ДОТООД АУДИТ",
      key: "Hk9SjjRuwECDcljM3342pQ",
      skin: "audit",
      logo: "media/logo/soyombo.png",
      bgLogin: "assets/bg/audit.jpg",
      hostPro: ['audit.gosmart.mn', 'audit-mofa.gosmart.mn', 'audit.mofa.gov.mn'],
      hostDev: ["192.168.0.115:80800", 
      '192.168.0.100:8080_x', '192.168.0.164_x:8080', '192.168.0.171:8080'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "https://audit-mofa-cdn.gosmart.mn/static/audit-help.pdf",
      
      hubBaseUrl: "https://audit-mofa.gosmart.mn/core/",
      baseUrl: "https://audit-mofa.gosmart.mn/mobcore/",

      PDFJS_URL: "https://audit-mofa-cdn.gosmart.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "https://audit-mofa-app.gosmart.mn",
      hasStreamServer: false,
    },

    {
      id: 9164,
      name: "Замын хөдөлгөөний мэдээлэл",
      key: "csxbNQ6PLk_z_Hw02ludeL",
      logo: "media/logo/mofa.svg",
      hostPro: ['zhut.gosmart.mn'],
      hostDev: ['192.168.0.115:8x080', 
      '192.168.0.100:8080_x', '192.168.0.164_:8080'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      directPage:{
        has: true,
        route: 'penaltyDashboard'
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      hubBaseUrl: "http://103.9.88.247/core/",
      baseUrl: "http://103.9.88.247:2020/",

      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9290,
      name: "ЭЧВОД-1",
      logo: "media/logo/echvod1.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "4PLBfzTFa0O_R_gJ0ub9Ow",

      hostPro: ["echvod1.gosmart.mn"],
      hostDev: [
        "192.168.0.105:8080_s",
        "192.168.0.115:80x80",
        "192.168.0.100:8080_j",
        "192.168.42.2:8081",
        "192.168.0.100:8080_tch"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: 'https://www.my-railway.com/core/',
      // baseUrl: 'https://my-railway.com/mobCore/',
      v2BaseUrl: "https://v2.echvod1.gosmart.mn",
      //hubBaseUrl: 'https://app.gosmart.mn/coredev/',
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9291,
      name: "ХХҮЕГ",
      logo: "media/logo/halamj.png",
      bgLogin: "assets/img/covid.svg",
      skin: "is-khudulmur",
      key: "KV8lkRKi_EWjV5MHOeB7Mg",
      hostPro: ["hudulmur.gosmart.mn", "surgalt.hudulmur-halamj.gov.mn"],
      hostDev: ["192.168.1.115:80x80", "192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: false,
      PDFJS_URL: "https://cdn-surgalt.hudulmur-halamj.gov.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "http://hudulmur-app.gosmart.mn",
      hasStreamServer: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "",
      reportBaseUrl: "https://surgalt.hudulmur-halamj.gov.mn/report/",
      hubBaseUrl: "https://surgalt.hudulmur-halamj.gov.mn/core/",
      baseUrl: "https://surgalt.hudulmur-halamj.gov.mn/mobCore/"
    },

    {
      id: 9292,
      name: "ЗТХТ",
       logo: "media/logo/rtdc.png",
      // bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "FN5PtdEgU0mKXK42q2KSog",
      hostPro: ["dynamic.roadpay.mn", "rtdc-erp.gosmart.mn"],
      hostDev: ["192.168.0.115:80805", "192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: false,
      // PDFJS_URL: "https://cdn-surgalt.hudulmur-halamj.gov.mn/static/pdfobject/web/viewer.html",
      // v2BaseUrl: "http://hudulmur-app.gosmart.mn",
      // hasStreamServer: false,
      // helpPageUrl: "http://support.gosmart.mn",
      // streamBaseUrl: "",
      hubBaseUrl: "https://rtdc.gosmart.mn/core/",
      baseUrl: "https://rtdc.gosmart.mn/mobCore/"
    },

    {
      id: 9292,
      name: "Achaa.ezam.mn",
       logo: "media/logo/rtdc.png",
       bgLogin: "assets/img/achaa_bg.jpeg",
      skin: "",
      key: "FN5PtdEgU0mKXK42q2KSog",
      hostPro: ["achaa.ezam.mn"],
      hostDev: ["192.168.1.115:80x80", "192.168.0.105:80801", "192.168.0.186:808_0_1"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: true,
      // PDFJS_URL: "https://cdn-surgalt.hudulmur-halamj.gov.mn/static/pdfobject/web/viewer.html",
      // v2BaseUrl: "http://hudulmur-app.gosmart.mn",
      // hasStreamServer: false,
      // helpPageUrl: "http://support.gosmart.mn",
      // streamBaseUrl: "",
      hubBaseUrl: "https://rtdc.gosmart.mn/core/",
      baseUrl: "https://rtdc.gosmart.mn/mobCore/"
    },


    {
      //# mori dashboard shinjleh ugaan tehnology innovatsiin negdsen tsahim svljee
      id: 98,
      name: "Динамик МОРИ",
      //key: "zIGhSWMcrLTeOUvByGtMr1",
      key: "br_bHWaQ2k2TqS7__VInhZ",
      logo: "media/icon.png",
      skin: "is-mori",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "mori.gosmart.mn" ],
      hostDev: [ "192.168.0.115:88080", "172.20.10.3:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9298,
      namespace: 'stf.project',
      name: "ТӨСЛИЙН УДИРДЛАГЫН СИСТЕМ",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/sc2025.png",
      skin: "is-stf",
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "project.stf.gov.mn", "project-stf.gosmart.mn" ],
      hostDev: [ "192.168.1.91:8080c", "192.168.1.7:80x80", "172.20.10.3:8x080", "192.168.0.100x:80x80", "192.168.0.186:808_0", "192.168.0.1x82:80x80", "192.168.1.5:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/",
      v2BaseUrl: "https://v2.project.stf.gosmart.mn"
    },
    {
      id: 9298,
      namespace: 'stf.researcher',
      name: "СУДЛААЧИЙН МЭДЭЭЛЛИЙН САН",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/stfresearcher.png",
      skin: "is-stfresearcher",
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "researcher.stf.gov.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/",
      v2BaseUrl: "https://v2.project.stf.gosmart.mn"
    },
    {
      id: 9298,
      namespace: 'stf.startup',
      name: "Гарааны компани",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/stfstartup.png",
      skin: "is-startup",
      publicPage: {
        has: false,
      },
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "startup.stf.gov.mn"],
      hostDev: [ "192.168.0.115:8x080", "192.168.1.105:8081"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },
    {
      id: 9298,
      namespace: 'stf.doctor',
      name: "Докторын зэрэг хамгаалуулах зөвлөл",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/stfdoctor2025.png",
      skin: "is-stfdoctor",
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "zuvlul.stf.gov.mn"],
      hostDev: [ "192.168.1.115:8x080", "172.20.10.3:80x80", "192.168.0.1z82:80z80", "192.168.1.17:808x0"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },
    // {
    //   id: 9313,
    //   name: "Боловсрол, шинжлэх ухааны яам",
    //   key: "yUtbesVhbUS84GqmjXl9Tg",
    //   logo: "media/logo/stfp.png",
    //   bgLogin: "assets/img/sc.png",
    //   skin: "is-stf",
    //   publicPage: {
    //     has: true,
    //     route: 'landingPage'
    //   },
    //   register: false,
    //   learnConfig: {
    //     course: {
    //       showAlert: true
    //     }
    //   },
    //   hostPro: [ "project.stf.goxxv.mn", "project-stf.gosmart.mn" ],
    //   hostDev: [ "192.168.0.115:80x80", "192.168.1.7:8080", "172.20.10.3:80x80",
    //   "192.168.0.100x:8080", ],
    //   fileUploadSize: {
    //     default: {
    //       size: 204800,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
    //     },
    //     student: {
    //       size: 102400,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
    //     }
    //   },

    //   hubBaseUrl: "https://project-stf.gosmart.mn/core/",
    //   baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    // },
    {
      id: 9298,
      name: "Шинжлэх ухааны салбарын түлхүүр үгийн сан",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/ac_icon.png",
      bgLogin: "assets/img/stf.png",
      skin: "is-stf",
      publicPage: {
        has: false,
      },
      limitedRoutes: [
        '_systemLocTypeConfig'
      ],
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "toli.ac.mn", "keyword.stf.gov.mn" ],
      hostDev: [ "192.168.1.17:80c80", "172.20.10.3:8x080",
      "192.168.0.1x68:808x0", "192.168.1.5:8080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },

    {
      //# mori dashboard shinjleh ugaan tehnology innovatsiin negdsen tsahim svljee
      id: 9299,
      name: "Тогтвортой ноос ноолуурын эвсэл",
      key: "xOcCffvn4kSBLzIGjLd4vg",
      logo: "media/logo/nartc.png",
      skin: "",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "training.nartc.mn", "training.sustainablefibre.mn" ],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8x080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "https://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9300,
      name: "Тэтгэлгийн нэгдсэн систем",
      key: "hO1esH8BKkCDMYp3ysB7wg",
      logo: "media/logo/elf.png",
      skin: "",
      publicPage: {
        has: false,
      },
      register: false,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "elf.gosmart.mn" ],
      hostDev: [ "192.168.1.115:80x81", "172.20.10.3:8x080", "192.168.0.18x2:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://elf.gosmart.mn/core/",
      baseUrl: "https://elf.gosmart.mn/mobCore/"
    },

    {
      id: 9306,
      name: "CENTURY 21",
      key: "cBXeHw9r2UejtEtehc9Gaw",
      logo: "media/logo/c21.png",
      skin: "",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "hub.c21.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "https://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9307,
      name: "Шүүхийн ерөнхий зөвлөл",
      key: "uUn_85_69USV9t9ZUmeGeg",
      logo: "media/logo/jud.png",
      bgLogin: "assets/img/jud.png",
      skin: "is-jud",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "edu.judcouncil.mn", "103.11.195.40", "192.168.99.9", "192.168.0.180", "jud.gosmart.mn"],
      hostDev: [ "192.168.1.115:80x80", "172.20.10.3:80x80",
       "192.168.0.18x2:80x80"
     ],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "http://edu-help.judcouncil.mn",

      hasStreamServer: true,
      reportBaseUrl: "https://103.11.195.40:8091/",
      streamBaseUrl: "https://103.11.195.40:1935/",

      PDFJS_URL: 'https://edu.judcouncil.mn/cdn/static/pdfobject/web/viewer.html',
      cdnBaseUrl: 'https://edu.judcouncil.mn/cdn/',

      // hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"

      // hubBaseUrl: "http://edu.judcouncil.mn/core/",
      // baseUrl: "http://edu.judcouncil.mn/mobcore/"

      // hubBaseUrl: "http://103.11.195.40/core/",
      // baseUrl: "http://103.11.195.40/mobcore/"

      hubBaseUrl: "https://edu.judcouncil.mn/core/",
      baseUrl: "https://edu.judcouncil.mn/mobcore/"
    },

    {
      id: 9309,
      name: "Витафит групп",
      key: "0tQsXapmpEu5GMyDSbclBA",
      logo: "media/logo/vitafit.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "vitafit.gosmart.mn"],
      hostDev: [ "192.168.1.17:8x080", "172.20.10.3:808x0" ],
      fileUploadSize: {
        default: {
          size: 2500000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2.5GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9310,
      name: "Шүүх шинжилгээний ерөнхий газар",
      key: "zV9NaDEYTEuq23EBk8QWeg",
      logo: "media/logo/nfa.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "nfa.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9311,
      name: "Монголын үнэт цаасны арилжаа эрхлэгчдийн холбоо",
      nameShort: "МҮЦАЭХ",
      key: "Aw96iFc6M0CbH0tPueNbNA",
      logo: "media/logo/masd2024.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "e.masd.mn"],
      hostDev: [ "192.168.1.91:8080", "172.20.10.3:80x80",
     "192.168.0.1x64:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      true: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://e.masd.mn/core/",
      baseUrl: "https://e.masd.mn/mobCore/",
      v2BaseUrl: "https://v2.masd.gosmart.mn"
    },

    {
      id: 9312,
      name: "Терроризмтой тэмцэх зөвлөл",
      key: "1xP7K5L3aUKHOsSGrqsr5g",
      logo: "media/logo/nctc.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "surgalt.nctc.gov.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8x080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9315,
      name: "Edu Gov",
      key: "RECGYYAuGEmfNA0o_t16pA",
      logo: "media/logo/onoo.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "surgalt.nctc.gov.mn", "erp.onoo.mn", "surgalt.onoo.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9275,
      name: "Цагдаагийн ерөнхий газрын цахим сургалт",
      nameShort: "ЦЕГ цахим сургалт",
      key: "jSUk2F5JX0KaPdXnKwgdyg",
      skin: "",
      logo: "media/logo/police.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['police.gosmart.mn', 'esurgalt.police.gov.mn'],
      hostDev: ['192.168.0.115:80x80', 'http://192.168.0.177:8081/',
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream235.gosmart.mn/",
      hasStreamServer: true,
      // streamBaseUrl: "https://stream-gate.gosmart.mn/",
      cdnBaseUrl: 'https://police-cdn.gosmart.mn/',
      hubBaseUrl: "https://police.gosmart.mn/core/",
      baseUrl: "https://police.gosmart.mn/mobCore/"

    },

    {
      id: 9365,
      name: "Цагдаагийн ерөнхий газрын цахим сургалт",
      nameShort: "ЦЕГ цахим сургалт",
      key: "zOwl3_wQKkGC8_sfSBEODQ",
      skin: "is-pittc",
      logo: "media/logo/police.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['e.pittc.edu.mn', 'surgalt.pittc.edu.mn', "pittc-academy.gosmart.mn",],
      hostDev: ['192.168.1.115:80x80'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      // streamBaseUrl: "https://stream235.gosmart.mn/",
      hasStreamServer: false,
      cdnBaseUrl: 'https://surgalt.pittc.edu.mn/cdn/',
      reportBaseUrl: "https://surgalt.pittc.edu.mn/report/",
      // hubBaseUrl: "https://e.pittc.edu.mn/core/",
      // baseUrl: "https://e.pittc.edu.mn/mobCore/"
      hubBaseUrl: "https://surgalt.pittc.edu.mn/core/",
      baseUrl: "https://surgalt.pittc.edu.mn/mobCore/"
    },

    {
      id: 9141,
      name: "Мэдээлэл, Технологийн Үндэсний Парк",
      key: "T9LuKWNQVj3QSZXxZ0mNZa",
      //skin: "magic",
      logo: "media/logo/itpark.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['itpark.gosmart.mn'],
      hostDev: ['192.168.0.115:8x080', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.itpark.gosmart.mn",
       hubBaseUrl: "https://itpark.gosmart.mn/core/",
       baseUrl: "https://itpark.gosmart.mn/mobCore/",
    },

    {
      id: 9343,
      name: "Max Group",
      key: "Yz3wDtxAS0O29YjDMN_rYg",
      logo: "media/logo/maxgroup.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "maxgroup.gosmart.mn"],
      hostDev: [ "192.168.0.115:8x080", "172.20.10.3:80x80" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9344,
      name: "Тээвэр хөгжлийн банк",
      key: "vU3U0oBEqkqxxUag37HZsA",
      logo: "media/logo/transbank.png",
      skin: "is-transbank",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "transbank.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://transbank.gosmart.mn/core/",
      baseUrl: "https://transbank.gosmart.mn/mobCore/",
    },

    {
      id: 9352,
      name: "Капитрон банк",
      key: "iPxrhYmlnEu_sXytTmz1WA",
      logo: "media/logo/capitronbank.png",
      logowt: "media/logo/capitronwt.svg",
      skin: "is-capitron",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "lms.capitronbank.mn"],
      hostDev: ["192.168.1.115:808x0", "192.168.1.7:8080", "192.168.0.18x2:8x080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      v5ExamBaseUrl: "http://exam-capitronbank.gosmart.mn",
      register: false,
      v2BaseUrl: "https://v2.capitronbank.gosmart.mn",

      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://lms.capitronbank.mn/core/",
      baseUrl: "https://lms.capitronbank.mn/mobCore/",
    },

    {
      id: 9353,
      name: "Таван Богд Финанс",
      key: "THuEzJN0MU2Q2C2CzZ2FvQ",
      logo: "media/logo/shareon.png",
      skin: "is-shareon",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "shareon.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80", "192.168.0.18x2:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9354,
      name: "Нью прогресс групп",
      key: "R5A6c6J4XEmOM9CqYwAP8Q",
      logo: "media/logo/npg.png",
      skin: "is-npg",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "training.npg.mn"],
      hostDev: [ "192.168.0.115:8x080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9355,
      name: "Батцэрэн.мн",
      key: "C6AlwxA2_UugFZ4ki1SDSg",
      logo: "media/logo/battseren.png",
      skin: "is-battseren",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "battseren.mn", "www.battseren.mn"],
      hostDev: [ "192.168.0.115:8x080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9357,
      name: "MMSE Training center",
      nameShort: " ",
      key: "AdL2lypRJ0eZ5LCl3YgxSQ",
      logo: "media/logo/mmse.png",
      skin: "is-mmse",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "training.mmse.mn", "www.training.mmse.mn"],
      hostDev: [ "192.168.0.115:8x080",
        "192.168.0.18x2:80x80"
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      // baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9358,
      name: "Парламентын судалгаа,<br /> хөгжлийн хүрээлэн",
      nameShort: " ",
      key: "hmykcEyvm0WfcwWxLYVdUg",
      logo: "media/logo/soyombo_blue.png",
      skin: "is-resparliament",
      publicPage: {
        has: true,
        route: "landingPage",
        readUrl: "https://research.parliament.mn"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["parliament.gosmart.mn", "training.parliament.mn"],
      hostDev: [ "192.168.1.115:80x80", "192.168.0.18x2:80x80", "192.168.1.17:80x80"],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",

      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      reportBaseUrl: "https://rpt.parliament.gosmart.mn/",
      
      // hubBaseUrl: "https://parliament.gosmart.mn/core/",
      // baseUrl: "https://parliament.gosmart.mn/mobcore/",
      hubBaseUrl: "https://training.parliament.mn/core/",
      baseUrl: "https://training.parliament.mn/mobcore/",
      //baseUrl: "https://v4-research.parliament.gosmart.mn/mobcore/"
      // baseUrl: "https://devapi.gosmart.mn/"
      v2BaseUrl: "http://training.parliament.mn/app",
    },
    {
      id: 9358,
      name: "Парламентын судалгаа, хөгжлийн хүрээлэн",
      nameShort: " ",
      key: "hmykcEyvm0WfcwWxLYVdUg",
      logo: "media/logo/soyombo_blue.png",
      skin: "is-resparliament",
      publicPage: {
        has: false,
        route: "landingPage",
        readUrl: "https://research.parliament.mn"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "v4-research.parliament.gosmart.mn", "research.parliament.mn"],
      hostDev: [ "192.168.0.115:80x81", "192.168.0.18x2:80x80", "192.168.8.16:8080", "172.20.10.3:8080"],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",

      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      reportBaseUrl: "https://rpt.parliament.gosmart.mn/",
      
      //hubBaseUrl: "https://v4-research.parliament.gosmart.mn/core/",
      //baseUrl: "https://v4-research.parliament.gosmart.mn/mobcore/"

      hubBaseUrl: "https://training.parliament.mn/core/",
      baseUrl: "https://training.parliament.mn/mobcore/"

      //baseUrl: "https://parliament.gosmart.mn/mobcore/"
      // baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9356,
      name: "#iCER",
      key: "AKNAXUVNfUeq9NFPYtN8ZA",
      logo: "media/logo/icer.png",
      skin: "is-icer",
      groupNameHide: true,
      groupLogoWidth: 210,
      publicPage: {
        has: false,
        route: "landingPage"
      },
      bgLogin: "assets/img/icer-white.png",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "icer.gosmart.mn"],
      hostDev: [ "192.168.0.115:8x080",
        "192.168.0.16x4:80x80",
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9345,
      name: "Educate",
      key: "__d3NxLzN06X2G2CGtEHYg",
      logo: "media/logo/educate.png",
      skin: "is-educate",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "educate.mn", "www.educate.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://educate.mn/core/",
      baseUrl: "https://educate.mn/mobCore/",
    },

    {
      id: 9346,
      name: "СИТИ Их сургууль",
      key: "CxARyH31h0KD4tzqFaAZSg",
      logo: "media/logo/citi.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "citi.gosmart.mn", "www.citi.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://citi.gosmart.mn/core/",
      baseUrl: "https://citi.gosmart.mn/mobCore/",
    },

    {
      id: 9346,
      name: "СИТИ Их сургууль",
      key: "CxARyH31h0KD4tzqFaAZSg",
      logo: "media/logo/citi.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "citi.gosmart.mn", "www.citi.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://citi.gosmart.mn/core/",
      baseUrl: "https://citi.gosmart.mn/mobCore/",
    },

    {
      id: 9349,
      name: "Өвөрхангай",
      key: "_EvpYk40l0y9WBI_aGrvoA",
      logo: "media/logo/tats/uv-mini.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "nevtrelt.uvurkhangai.gov.mn", "www.nevtrelt.uvurkhangai.gov.mn"],
      hostDev: [ "192.168.0.115:8x080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nevtrelt.uvurkhangai.gov.mn/core/",
      baseUrl: "https://nevtrelt.uvurkhangai.gov.mn/mobCore/",
    },
    {
      id: 9350,
      name: "Дархан",
      key: "_pET4wSGckyQ0SG3WAOlHQ",
      logo: "media/logo/tats/dar-mini.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "nevtrelt.darkhan.gov.mn", "www.nevtrelt.darkhan.gov.mn"],
      hostDev: [ "192.168.0.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nevtrelt.darkhan.gov.mn/core/",
      baseUrl: "https://nevtrelt.darkhan.gov.mn/mobCore/",
    },
    {
      id: 9360,
      name: "Харилцаа холбооны Зохицуулах Хороо",
      nameShort: " ",
      key: "JZQMMFJ3306wASnuhqDTeQ",
      logo: "media/logo/crc.png",
      skin: "is-crc",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["crc.gosmart.mn", "www.crc.gosmart.mn"],
      hostDev: ["192.168.0.115:8082"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      // baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9366,
      name: "Оргил худалдааны төв",
      nameShort: " ",
      key: "A5Kip7eGJkCf4pPQtrmKHw",
      logo: "media/logo/orgil.png",
      skin: "is-orgil",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["orgil.gosmart.mn", "www.orgil.gosmart.mn"],
      hostDev: ["192.168.1.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9369,
      name: "Би Би Си Эм ХХК",
      nameShort: " ",
      key: "ETbJzCmKnEeQeQAdwNPfRQ",
      logo: "media/logo/bbcm.png",
      skin: "is-bbcm",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["training-success.mn", "www.training-success.mn"],
      hostDev: ["192.168.1.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9371,
      name: "M Mart",
      nameShort: " ",
      key: "gj8hyIcBw0OIfqXkmPhY8Q", 
      logo: "media/logo/mmart.png",
      skin: "is-mmart",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["mmart.gosmart.mn", "www.mmart.gosmart.mn"],
      hostDev: ["192.168.1.115:808x0"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9372,
      name: "Үнэт мэталл, үнэт чулуу, үнэт эдлэлийн салбарын үндэсний мэргэжлийн нэгдсэн холбоо",
      nameShort: "Metal Mongolia",
      key: "Bu4B_PN2AEuy8mXLMEf9lw", 
      logo: "media/logo/metal.png",
      skin: "is-metal",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["metal.gosmart.mn", "www.metal.gosmart.mn"],
      hostDev: ["192.168.1.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9373,
      name: "Монгол нягтлан сургалтын төв",
      nameShort: "Монгол нягтлан",
      key: "4BSol9tt8EuG_CDT4r29Lw", 
      logo: "media/logo/v4.png",
      skin: "is-etailan",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["etailan.mn", "www.etailan.mn"],
      hostDev: ["192.168.1.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9379,
      name: "Газар Зохион Байгуулалт, Геодези, Зураг Зүйн Ерөнхий Газар",
      nameShort: "ГЗБГЗЗЕГ",
      key: "2XOp1IP0Dku_Fm75qGa6fA", 
      logo: "media/logo/gazar_logo.png",
      // logo: "media/logo/soyombo.png",
      skin: "is-egazar",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["egazar.gosmart.mn", "www.egazar.gosmart.mn", "surgalt.gazar.gov.mn", "www.surgalt.gazar.gov.mn"],
      hostDev: ["192.168.1.91:80x80", "192.168.1.133:8080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      hasStreamServer: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://prod-api.gazar.gosmart.mn/core/",
      baseUrl: "https://prod-api.gazar.gosmart.mn/mobcore/"
    },
    {
      id: 9384,
      name: "22",
      nameShort: "22",
      key: "_1UBNYKMyEGa9CC9XfOCog", 
      logo: "",
      skin: "is-egazar",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [],
      hostDev: ["192.168.1.91:80c80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      baseUrl: "https://parking22.mn/mobCorev4/"
    },
    {
      id: 9385,
      name: "Orchlon School",
      nameShort: "Orchlon School",
      key: "8_1dThS8kEeYg_V6mHwGrw", 
      logo: "media/logo/orchlon.png",
      skin: "is-orchedu",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["test.orchlon.mn", "www.test.orchlon.mn"],
      hostDev: ["192.168.1.115:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9386,
      name: "Хөгжил групп",
      nameShort: "",
      key: "piLP7srM6UOq3Ki2PAUNsw", 
      logo: "media/logo/khugjil_blue.png",
      // logo: "media/logo/khugjil.png",
      skin: "is-khugjil",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["khugjil.gosmart.mn", "www.khugjil.gosmart.mn"],
      hostDev: ["192.168.1.115:8x080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      hasHlsServer: false,
      register: false,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9387,
      name: "Монголын бичил уурхайн нэгдсэн дээвэр холбоо ",
      nameShort: "",
      key: "4sjflYxVdES93el7pmbseA", 
      logo: "media/logo/bichil-uurkhai.png",
      skin: "is-bichil-uurkhai",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ["bichil-uurkhai.gosmart.mn", "www.bichil-uurkhai.gosmart.mn"],
      hostDev: ["192.168.1.91:80x80"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      hasHlsServer: false,
      register: true,
      helpPageUrl: "http://support.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
  ],
  roleDefaultPages: [
    {
      id: 1,
      title: "Динамик Платформ",
      roles: [
        {
          icon: "home",
          title: "Эхлэл",
          role: ["officehome"],
          rawLink: "/wall"
        }
      ]
    },
    {
      id: 5,
      title: "Судлаач сонгон шалгаруулах систем",
      roles: [
        {
          icon: "check-square",
          title: "Сонгон шалгаруулах зар",
          role: ["researcheradmin"],
          rawLink: "/resParl/zar/622/0/0"
        }
      ]
    },
    {
      id: 301,
      title: "Шалган зааварлагчийн модуль",
      roles: [
        {
          icon: "bar-chart-2",
          title: "Хянах самбар",
          role: ["tr_chief", "tr_tch_chief", "tr_trainer"],
          rawLink: "/tr/dashboard",
        },
        // {
        //   icon: "users",
        //   title: "Шалган зааварчилгаа",
        //   role: ["tr_trainer", "tr_driver"],
        //   rawLink: "/tr/travel/557/0/0/0",
        // },
        {
          icon: "alert-circle",
          title: "Машинчийн санамж",
          role: ["tr_trainer", "tr_tch_chief", "tr_driver"],
          rawLink: "/tr/sanamj/559/0/0/0/0/0",
        },
        {
          icon: "slack",
          title: "Үүрэг даалгавар",
          role: ["tr_trainer", "tr_tch_chief", "tr_driver"],
          rawLink: "/tr/assign/333/0/0/0/0/0",
        }
      ]
    },
    {
      id: 2,
      title: "Сургалтын систем",
      roles: [
        {
          icon: "database",
          title: "Сургалтын админ",
          role: ["learningadmin"],
          rawLink: "/lms/admin/115/0/0"
        },
        {
          icon: "book",
          title: "Багш",
          role: ["learningteacher"],
          // rawLink: "/lms/dashboard",
          rawLink: "/lms/admin/115/0/0"
        },
        {
          icon: "award",
          title: "Суралцагч",
          role: [
            "learningstudent",
            "learningoffice",
            "learningteacher",
            "learningadmin"
          ],
          rawLink: "/lms/participant"
        },
        {
          icon: "book-open",
          title: "Номын санч",
          role: ["learnlibraryorder"],
          rawLink: "/lms/library/0/0/null/4"
        },
        {
          icon: "pie-chart",
          title: "Санал асуулга",
          role: ["learnpoll"],
          rawLink: "/goform/pollAdmin",
          version: 2,
          v2: {
            type: 1,
            name: "formPollAdmin",
            link: "/goform/pollAdmin"
          },
        },   
        {
          icon: "book-open",
          title: "Тайлан",
          role: ["reporttagviewer"],
          rawLink: "/report/list/451/0/0"
        },     
        {
          icon: "activity",
          title: "Хөрөнгө",
          role: ["asset"],
          rawLink: "/asset/dashboard"
        },

        {
          icon: "database",
          title: "Цахим сургалт, шалгалтын бүртгэл",
          role: ["memberexam"],
          rawLink: "/member/examRegistration/340/0/0"
        },
      ]
    },

    {
      id:2100,
      title:'Onboarding module',
      roles:[
        {
          title: 'Шинэ ажилтан',
          icon: "heart",
          role: ['buddy_participant'],
          rawLink: "/buddy/participant",
        },
        {
          title: 'Buddy ажилтан',
          icon: "users",
          role: ['buddy_worker'],
          rawLink: "/buddy/worker",
        },
        {
          title: 'Нэгжийн удирдлага',
          icon: "list",
          role: ['buddy_chief'],
          rawLink: "/buddy/chief",
        },
        // {
        //   title: 'Админ',
        //   icon: "pie-chart",
        //   role: ['buddy_participant'],
        //   rawLink: "/buddy/depart/dashboard",
        // },
        {
          title: 'Админ',
          icon: "pie-chart",
          role: ['lmsbuddyadmin'],
          rawLink: "/buddy/admin_dashboard",
        },
        {
          title: 'Тохиргоо',
          icon: "sliders",
          role: ['buddy_setting'],
          rawLink: "/buddy/todoAdmin/614/0/0",
        },
        // {
        //   title: 'Тайлан',
        //   icon: "clipboard",
        //   role: ['lmsbuddyadmin'],
        //   rawLink: "/buddy/admin_report",
        // },
        // {
        //   title: 'Buddy',
        //   icon: "users",
        //   role: ['lmsbuddyadmin'],
        //   rawLink: "/buddy/admin_buddy",
        // }
      ]
    },

    {
      id: 4000,
      title: "Төв замын түр зөвшөөрөл",
      roles: [
        {
          icon: "database",
          title: "Төв замын түр зөвшөөрөл",
          role: ["zamadmin"],
          rawLink: "/zam/zovshoorol/608"
        }
      ]
    },

    {
      id: 1012,
      title: "Докторын зөвлөл",
      roles: [
        {
          icon: "database",
          title: "Зөвлөлийн хүсэлтүүд",
          role: ["stf_doctor_admin"],
          rawLink: "/dz/apply/599/0/0/0/0/0"
        }
      ]
    },

    {
      id: 1010,
      title: "Төслийн бүртгэлийн систем",
      roles: [
        {
          icon: "database",
          title: "Админ",
          role: ["stf_proj_admin"],
          rawLink: "/stf/dashboard"
        },
        {
          icon: "database",
          title: "Төслүүд",
          role: ["stf_proj_admin", "stf_proj_mergejilten"],
          rawLink: "/stf/apply/561/0/0/0/0/0"
        },
        {
          icon: "book",
          title: "Шинжээч",
          role: ["stf_proj_shinjeech"],
          rawLink: "/stf/dashboard"
        },
        {
          icon: "award",
          title: "Судлаач",
          role: ["stf_proj_sudlaach"],
          rawLink: "/stf/researcher"
        },
      ]
    },

    {
      id: 1000,
      title: "Товчоодын нэвтрэлтийн нэгдсэн систем",
      roles: [
        // {
        //   icon: "database",
        //   title: "Админ",
        //   role: ["stf_proj_admin"],
        //   rawLink: "/stf/dashboard"
        // },
        // {
        //   icon: "book",
        //   title: "Шинжээч",
        //   role: ["stf_proj_shinjeech"],
        //   rawLink: "/stf/dashboard"
        // },
        {
          icon: "truck",
          title: "Ачаа тээвэрлэх хүсэлт",
          role: ["ezam_transit_admin"],
          rawLink: "/tats/atx/596"
        },
      ]
    },

    {
      id: 1020,
      title: "Боловсролын зээлийн систем",
      roles: [
        {
          icon: "pie-chart",
          title: "Удирдлагын самбар",
          role: ["elf_admin"],
          rawLink: "/elf/dashboard"
        },
        {
          icon: "award",
          title: "Суралцагч",
          role: ["elf_student"],
          rawLink: "/elf/student"
        },
      ]
    },

    {
      id: 4,
      title: "Албан хэрэг хөтлөлт",
      roles: [
        {
          icon: "file-text",
          title: "Ирсэн бичгийн бүртгэл",
          version: 2,
          v2: {
            type: 1,
            name: "inDocList",
            link: "/archive/inDocList"
          },
          role: ["archive", "archiveadmin"],
          rawLink: "/archive/inDocList"
        },
        {
          icon: "file-text",
          title: "Явсан бичгийн бүртгэл",
          version: 2,
          v2: {
            type: 1,
            name: "outDocList",
            link: "/archive/outDocList"
          },
          role: ["archive", "archiveadmin"],
          rawLink: "/archive/outDocList"
        }
      ]
    },
    {
      id: 8,
      title: "Аудит",
      roles: [
        {
          icon: "award",
          title: "Аудит",
          role: ["audit"],
          rawLink: "/audit/dashboard",
        }
      ]
    },
    {
      id: 5,
      title: "Хүний нөөц, Гишүүнчлэл",
      roles: [
        {
          icon: "user-plus",
          title: "Хүний нөөц",
          role: ["hradmin"],
          rawLink: "/hr/list/138"
        },
        {
          icon: "user-plus",
          title: "Гишүүнчлэл",
          role: ["memberadmin", "membermanager", "membercompany"],
          rawLink: "/member/list/390"
        },
        {
          icon: "bookmark",
          title: "Нийтлэл",
          role: ["mobilefeedpostadmin"],
          rawLink: "/lms/mobileFeedPostAdmin/604/0/0"
        },
        {
          icon: "user-plus",
          title: "Гишүүн хайх",
          role: ["memberdb"],
          version: 2,
          v2: {
            type: 1,
            name: "memberDb",
            link: "/member/db"
          },
          rawLink: "/member/db"
        }
      ]
    },
    {
      id: 55,
      title: "ТАДС",
      roles: [
        {
          icon: "user-plus",
          title: "ТАДС Админ",
          role: ["tadsadmin"],
          rawLink: "/tadsadmin/sequence/512/0/0"
        }
      ]
    },
    {
      id: 6,
      title: "Оюуны өмч",
      roles: [
        {
          icon: "award",
          title: "Зуучлалын үйл ажиллагаа эрхлэгч",
          role: ["ipombroker"],
          rawLink: "/ipom/brokers/95326"
          //rawLink: '/ipom/broker/526/0/0',
        },
        {
          icon: "briefcase",
          title: "Итгэмжлэгдсэн төлөөлөгч",
          role: ["ipomagent"],
          rawLink: "/ipom/agents/95327"
          //rawLink: '/ipom/agent/527/0/0',
        },
        {
          icon: "award",
          title: "Бүтээгдэхүүний загвар",
          role: ["ipombuteegdehuun"],
          rawLink: "/ipom/product/99416"
        },
        {
          icon: "award",
          title: "Ашигтай загвар",
          role: ["ipomashigtaizagvar"],
          rawLink: "/ipom/ashigtai_zagvar/99415"
        },
        {
          icon: "award",
          title: "Шинэ бүтээл",
          role: ["ipomshinebuteel"],
          rawLink: "/ipom/shine_buteel/99414"
        },
        {
          icon: "award",
          title: "Барааны тэмдэг",
          role: ["ipommark"],
          rawLink: "/ipom/baraanii_temdeg/99417"
        },
        {
          icon: "award",
          title: "Зохиогчийн эрх",
          role: ["ipomcopyright"],
          rawLink: "/ipom/copyright/99418"
        }
      ]
    },
    {
      id: 7,
      title: "Багшийн ажлын гүйцэтгэлийн үнэлгээ",
      roles: [
        {
          icon: "award",
          title: "Гүйцэтгэлийн үнэлгээ",
          role: ["mnuacattest", "mnuacattestkomiss", "mnuacattestown", "mnuacattesttenkhim"],
          rawLink: "/attestat/list/533/0/0/0",
          version: 8501,
        }
      ]
    },

    {
      id: 201,
      title: "mori",
      roles: [
        {
          icon: "award",
          title: "mori",
          role: ["mori"],
          rawLink: "/mori/dashboard",
        }
      ]
    },
    {
      id: 1501,
      title: "Академи",
      roles: [
        {
          icon: "pen-tool",
          title: "Сургалт",
          role: ["lmsacademy"],
          rawLink: "/lms/admin/115/0/0"
        },
        {
          icon: "book-open",
          title: "Нийтлэл",
          role: ["lmsacademy"],
          rawLink: "/lms/academypost/589/0/0"
        },
        {
          icon: "twitter",
          title: "Эвент",
          role: ["lmsacademy"],
          rawLink: "/lms/academyevent/270/0/0"
        },
        {
          icon: "video",
          title: "Вэбинар",
          role: ["lmsacademy"],
          rawLink: "/lms/academywebinar/590/0/0"
        },
        {
          icon: "mic",
          title: "Подкаст",
          role: ["lmsacademy"],
          rawLink: "/lms/academypodcast/588/0/0"
        }
      ]
    }
  ]
};
